exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span {\n  font-size: 12px;\n  font: Poppins;\n  color: #607d8b; }\n\n.table__header {\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 2rem; }\n  .table__header input {\n    max-width: 500px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/manter-aspect/manter-aspect.component.scss
// module id = ../../../../../src/app/components/manter-aspect/manter-aspect.component.scss
// module chunks = main